import React, { Component } from "react";

import {
  Wrapper,
  CardBody,
  Title,
  Copy,
  Bold,
  Row,
  Icon,
  Button
} from "app/NativeComponents/common";

import MessageHeaderImage from "./MessageHeaderImage";

import {
  determineMainOwnerInfo,
  dismissMobileKeyboard,
  formatAddress
} from "app/NativeActions";

class MessageHeader extends Component {
  renderTitle(item) {
    if (item) {
      if (item.owner_name) {
        return (
          <Wrapper style={{ maginTop: 5, marginBottom: 5 }}>
            <Copy>
              <Bold>
                {item.owner_name}
                {" - "}
                {item.lead_phone_number
                  ? item.lead_phone_number.phone_number
                  : ""}
              </Bold>
            </Copy>
          </Wrapper>
        );
      }

      return (
        <Wrapper style={{ maginTop: 5, marginBottom: 5 }}>
          <Copy>
            <Bold>
              {item.lead_phone_number
                ? item.lead_phone_number.phone_number
                : ""}
            </Bold>
          </Copy>
        </Wrapper>
      );
    }
  }

  renderAddress(item) {
    if (item && item.property_address) {
      const {
        property_address,
        property_address2,
        property_address_city,
        property_address_state,
        property_address_zip
      } = item;
      const address = formatAddress({
        address: {
          address: property_address,
          address2: property_address2,
          address_city: property_address_city,
          address_state: property_address_state,
          address_zip: property_address_zip
        }
      });

      return (
        <Wrapper>
          <Copy>{address.line1}</Copy>
          <Copy style={{ fontSize: 10 }}>{address.line2}</Copy>
        </Wrapper>
      );
    }
  }

  renderLabel(multisend_number) {
    const { colors } = this.props;
    if (
      (multisend_number.lead_phone_number &&
        (multisend_number.lead_phone_number.bad_phone == 1 ||
          multisend_number.lead_phone_number.blocked == 1 ||
          multisend_number.lead_phone_number.do_not_call == 1 ||
          multisend_number.lead_phone_number.landline == 1)) ||
      multisend_number.awaiting_response_lock_out
    ) {
      let label_color = colors.error_color;
      let label_text = "";
      let label_text_color = colors.white_text_color;

      if (multisend_number.awaiting_response_lock_out) {
        label_text = "Conversation Locked";
        label_text_color = colors.text_color;
        label_color = colors.gray_color;
      } else if (multisend_number.lead_phone_number.blocked == 1) {
        label_color = colors.error_color;
        label_text = "Blocked";
      } else if (multisend_number.lead_phone_number.is_litigator == 1) {
        label_color = colors.error_color;
        label_text = "Known Litigator";
      } else if (multisend_number.lead_phone_number.do_not_call == 1) {
        label_color = colors.error_color;
        label_text = "Do Not Call";
      } else if (multisend_number.lead_phone_number.landline == 1) {
        label_color = colors.background_color;
        label_text = "Landline";
        label_text_color = colors.text_color;
      } else if (multisend_number.lead_phone_number.bad_phone == 1) {
        label_color = colors.error_color;
        label_text = "Wrong Number";
      } else if (multisend_number.lead_phone_number.expected_undeliverable) {
        label_color = colors.background_color;
        label_text = "Undeliverable";
        label_text_color = colors.text_color;
      }

      if (!!label_text) {
        return (
          <Row style={{ marginTop: 5 }}>
            <Wrapper
              style={{
                padding: 3,
                borderRadius: 20,
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 10,
                backgroundColor: label_color
              }}
            >
              <Copy
                style={{
                  color: label_text_color,
                  fontSize: 10
                }}
              >
                <Bold>{label_text}</Bold>
              </Copy>
            </Wrapper>
          </Row>
        );
      }
    }
  }

  renderSkipButton() {
    const { colors, multisend_number } = this.props;

    if (
      multisend_number.lead_phone_number.bad_phone != 1 &&
      multisend_number.lead_phone_number.blocked != 1 &&
      multisend_number.lead_phone_number.do_not_call != 1 &&
      multisend_number.lead_phone_number.landline != 1 &&
      !multisend_number.awaiting_response_lock_out &&
      !multisend_number.received_response &&
      !multisend_number.timezone_lock_out
    ) {
      return (
        <Row>
          <Button
            style={{
              borderStyle: "solid",
              borderWidth: 1,
              padding: 10,
              borderRadius: 5,
              borderColor: colors.border_color,
              backgroundColor: colors.background_color
            }}
            onPress={() => {
              dismissMobileKeyboard();
              this.props.skipMultiSendNumber({
                lead_phone_id: multisend_number.lead_phone_number
                  ? multisend_number.lead_phone_number.owner_phone_number_id
                  : null,
                lead_phone_number: multisend_number.lead_phone_number
                  ? multisend_number.lead_phone_number.phone_number
                  : null
              });
            }}
          >
            <Copy>Skip Message</Copy>
          </Button>
        </Row>
      );
    }
  }

  render() {
    const { multisend_number, colors } = this.props;

    if (multisend_number) {
      return (
        <Wrapper
          style={{ backgroundColor: colors.background_color, zIndex: 1 }}
        >
          <CardBody
            style={{
              borderBottomWidth: 1,
              borderBottomColor: colors.border_color,
              borderBottomStyle: "solid",

              padding: 15
            }}
          >
            <Row style={{ alignItems: "flex-start" }}>
              <MessageHeaderImage item={multisend_number} colors={colors} />
              <Wrapper style={{ flex: 1 }}>
                {this.renderTitle(multisend_number)}
                {this.renderAddress(multisend_number)}
                {this.renderLabel(multisend_number)}
              </Wrapper>
              {this.renderSkipButton()}
            </Row>
          </CardBody>
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default MessageHeader;
